import React from "react";
import { Dialog, DialogTitle } from "@mui/material";
import { useForm } from "react-hook-form";
import Input from "../form/Input";
import { Button } from "../ui";

const AddLeaveTypeModal = ({ isOpen, onClose, handleCreateLeaveType }) => {
  const { control, register, handleSubmit } = useForm();

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <div className="p-5">
        <h1 className="text-xl font-bold mb-4">Add leave type</h1>
        <form onSubmit={handleSubmit(handleCreateLeaveType)}>
          <label htmlFor="" className="mb-2 block">
            Leave Type <span className="text-red-500">*</span>
          </label>
          <Input
            control={control}
            rules={{
              required: "Leave type is required",
            }}
            label="Leave type"
            name="leave_head_name"
            placeholder="Enter leave type"
          />

          <div className="flex items-center mt-4">
            <input
              id="is_document_required"
              type="checkbox"
              {...register("is_document_required")}
              className="mr-2"
            />
            <label htmlFor="is_document_required">Is document required?</label>
          </div>

          <Button type="submit" className="block mt-4 mx-auto">
            Create
          </Button>
        </form>
      </div>
    </Dialog>
  );
};

export default AddLeaveTypeModal;
